export function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  let hotel = JSON.parse(localStorage.getItem("hotel"));
  if (user && user.access) {
    return {
      Authorization: "Bearer " + user.access,
      "x-timezone": hotel ? hotel.time_zone : "America/New_York",
    };
  } else {
    return {};
  }
}
